module.exports = __webpack_public_path__ + "static/media/iceland3.565906fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/iceland3.png
// module id = 39
// module chunks = 0